module.exports = __webpack_public_path__ + "media/images/arrows/right-fab21c9dcbd9f57ffc3797f36ce63008.svg";